var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup p-24 p-lg-40" }, [
    _c("h3", {
      staticClass: "mb-24",
      domProps: { innerHTML: _vm._s(_vm.copyConfig.order_flow.title) }
    }),
    _vm._v(" "),
    _c("p", {
      staticClass: "small font-weight-light col-lg-10 px-0 mb-40",
      domProps: { innerHTML: _vm._s(_vm.copyConfig.order_flow.description) }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "offer-container" },
      [
        _c(
          "slide-y-down-transition",
          { staticClass: "row mb-n40", attrs: { group: "", tag: "div" } },
          [
            _vm._l(_vm.items.activity, function(activity) {
              return _c(
                "div",
                { key: activity.ID, staticClass: "col-6 col-lg-4 mb-40" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "select-wrapper",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleItem("activity", activity.ID)
                        }
                      }
                    },
                    [
                      _c("activity-card", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show,
                            expression: "show"
                          }
                        ],
                        attrs: {
                          activity: activity,
                          ratio: "284:200",
                          canHover: false
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "tag-row mt-12" }, [
                        _c("div", { staticClass: "tag-col" }, [
                          _c(
                            "div",
                            { staticClass: "tag tag-accent-light tag-xs" },
                            [_vm._v("Activiteit")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select-overlay",
                          class: {
                            active: _vm.selected.activity.includes(activity.ID)
                          },
                          style: { "padding-top": (200 / 284) * 100 + "%" }
                        },
                        [
                          _c("div", { staticClass: "overlay" }, [
                            _c("div", { staticClass: "select-circle" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-placeholder small" },
                              [_vm._v("Selecteer")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.items.speaker, function(speaker) {
              return _c(
                "div",
                { key: speaker.ID, staticClass: "col-6 col-lg-4 mb-40" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "select-wrapper",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleItem("speaker", speaker.ID)
                        }
                      }
                    },
                    [
                      _c("speaker-card", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show,
                            expression: "show"
                          }
                        ],
                        attrs: {
                          speaker: speaker,
                          ratio: "284:200",
                          canHover: false
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "tag-row mt-12" }, [
                        _c("div", { staticClass: "tag-col" }, [
                          _c(
                            "div",
                            { staticClass: "tag tag-accent-light tag-xs" },
                            [_vm._v("Spreker")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select-overlay",
                          class: {
                            active: _vm.selected.speaker.includes(speaker.ID)
                          },
                          style: { "padding-top": (200 / 284) * 100 + "%" }
                        },
                        [
                          _c("div", { staticClass: "overlay" }, [
                            _c("div", { staticClass: "select-circle" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-placeholder small" },
                              [_vm._v("Selecteer")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.items.location, function(location) {
              return _c(
                "div",
                { key: location.ID, staticClass: "col-6 col-lg-4 mb-40" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "select-wrapper",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleItem("location", location.ID)
                        }
                      }
                    },
                    [
                      _c("location-card", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show,
                            expression: "show"
                          }
                        ],
                        attrs: {
                          location: location,
                          ratio: "284:200",
                          canHover: false
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "tag-row mt-12" }, [
                        _c("div", { staticClass: "tag-col" }, [
                          _c(
                            "div",
                            { staticClass: "tag tag-accent-light tag-xs" },
                            [_vm._v("Locatie")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select-overlay",
                          class: {
                            active: _vm.selected.location.includes(location.ID)
                          },
                          style: { "padding-top": (200 / 284) * 100 + "%" }
                        },
                        [
                          _c("div", { staticClass: "overlay" }, [
                            _c("div", { staticClass: "select-circle" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-placeholder small" },
                              [_vm._v("Selecteer")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.items.staticItem, function(staticItem) {
              return _c(
                "div",
                { key: staticItem.ID, staticClass: "col-6 col-lg-4 mb-40" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "select-wrapper",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleItem("staticItem", staticItem.ID)
                        }
                      }
                    },
                    [
                      _c("static-card", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show,
                            expression: "show"
                          }
                        ],
                        staticClass: "w-100 h-100",
                        attrs: {
                          pages: _vm.pages,
                          staticItem: staticItem,
                          ratio: "284:200",
                          canHover: false
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "tag-row mt-12" }, [
                        _c("div", { staticClass: "tag-col" }, [
                          _c(
                            "div",
                            { staticClass: "tag tag-accent-light tag-xs" },
                            [_vm._v("Extra")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select-overlay",
                          class: {
                            active: _vm.selected.staticItem.includes(
                              staticItem.ID
                            )
                          },
                          style: { "padding-top": (200 / 284) * 100 + "%" }
                        },
                        [
                          _c("div", { staticClass: "overlay" }, [
                            _c("div", { staticClass: "select-circle" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-placeholder small" },
                              [_vm._v("Selecteer")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.items.gift, function(gift) {
              return _c(
                "div",
                { key: gift.ID, staticClass: "col-6 col-lg-4 mb-40" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "select-wrapper",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleItem("gift", gift.ID)
                        }
                      }
                    },
                    [
                      _c("gift-card", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show,
                            expression: "show"
                          }
                        ],
                        staticClass: "w-100 h-100",
                        attrs: {
                          pages: _vm.pages,
                          gift: gift,
                          ratio: "284:200",
                          canHover: false
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "tag-row mt-12" }, [
                        _c("div", { staticClass: "tag-col" }, [
                          _c(
                            "div",
                            { staticClass: "tag tag-accent-light tag-xs" },
                            [_vm._v("Gift")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select-overlay",
                          class: {
                            active: _vm.selected.gift.includes(gift.ID)
                          },
                          style: { "padding-top": (200 / 284) * 100 + "%" }
                        },
                        [
                          _c("div", { staticClass: "overlay" }, [
                            _c("div", { staticClass: "select-circle" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-placeholder small" },
                              [_vm._v("Selecteer")]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            })
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "popup-footer d-flex align-items-center" }, [
      _c("span", { staticClass: "small font-weight-light" }, [
        _vm._v(_vm._s(_vm.total) + " activiteit(en) geselecteerd.")
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn btn-accent ml-auto",
        attrs: { disabled: _vm.disabled },
        domProps: { innerHTML: _vm._s(_vm.copyConfig.order_flow.cta) },
        on: { click: _vm.submit }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }